/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAppSelector } from '@ibm-watson/shared/store';
import { selectIsSegmentKeyValid } from '../../../store/segment/selectors';
import { ConnectStepContent } from './ConnectStepContent';
import { ConnectStepMessages as messages } from './messages';

import './ConnectStep.scss';

interface ConnectStepProps {
  isLive: boolean;
  markStepComplete?: (boolean) => void;
  readOnly?: boolean;
}
export const ConnectStep: React.FC<ConnectStepProps> = ({
  isLive,
  markStepComplete,
  readOnly
}) => {
  const isSegmentKeyValid = useAppSelector(selectIsSegmentKeyValid);

  // When field is valid, mark step complete and enable next button
  useEffect(() => {
    markStepComplete(isSegmentKeyValid ?? false);
  }, [markStepComplete, isSegmentKeyValid]);

  return (
    <div className="ConnectStep">
      <div className="QuickSetup__step-title">
        <FormattedMessage {...messages.title} />
      </div>
      <div className="TabContent__spacer8" />
      <ConnectStepContent isLive={isLive} readOnly={readOnly} />
    </div>
  );
};
